<template>
	<div>
        <input id="scanText" v-on:change="scan" class="textfield" v-model="scanText" tabindex=0></input>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid1:PAGES.SCAN_INVENTORY_PAGE_ITEM,
			pageid2:PAGES.SCAN_INVENTORY_PAGE_BOX,
			pageid3:PAGES.SCAN_INVENTORY_PAGE_ALT,
			perms:[],
			scanText:'',
		}
	},
	async created () {
		this.perms = api.getPerms();
	},
	mounted () {
		document.getElementById("scanText").focus();
	},
	methods: {
        scan(){
			if(this.scanText=='') return;

			const itemVal = 'LDPAV2-'
			const boxVal = 'LDPAV2BOX-'
			const itemValMaersk = 'MAERSKV2-'

			var id = 0

            if(this.scanText.substr(0,itemVal.length)==itemVal){
				this.scanText = this.scanText.substr(itemVal.length)
				id = this.pageid1
			}else if(this.scanText.substr(0,itemValMaersk.length)==itemValMaersk){
				this.scanText = this.scanText.substr(itemValMaersk.length)
				id = this.pageid1
			}else if(this.scanText.substr(0,boxVal.length)==boxVal){
				this.scanText = this.scanText.substr(boxVal.length)
				id = this.pageid2
			}else{
				id = this.pageid3
			}

			api.postData(
				{
					type:"insert",
					data:{
						pageid:id,
						term:this.scanText,
					}
				}
			).then((res) => {
				if(id==this.pageid1){
					router.push('/0510?q='+this.scanText);
				}else if(id==this.pageid2){
					router.push('/0511?q='+this.scanText);
				}else{
					if(res.data.data!=null){
						router.push('/0510?q='+res.data.data);
					}else{
						router.go(-1);
					}
				}
			});
        },
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    border: 3px solid #35495E;
    border-radius: 20px;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    color:#35495E;
}

.textfield{
	margin:16px;
	font-size:24px;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

table {
    table-layout:auto;
    margin:auto;
    width:75%;
    border: none;
}

td {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/add/Scan_Inventory_Item.vue